import { useSuspenseHostQuery, useUnblockHostMutation } from '#api/hosts.queries.ts';
import { Code } from '#components/atoms/code/Code.tsx';
import { ConfirmDialog } from '#components/patterns/confirmations/confirm-dialog/ConfirmDialog.tsx';
import { hostKind } from '#util/host.ts';

type Props = {
  hostId: string;
  onClose: () => void;
};

export function UnblockHostDialog({ hostId, onClose }: Props) {
  const unblockHost = useUnblockHostMutation();
  const host = useSuspenseHostQuery(hostId).data.data;

  return (
    <ConfirmDialog
      title={<div className="truncate">Unblock {host.name}?</div>}
      disableAccept={unblockHost.isPending || !host}
      acceptButtonText="Unblock"
      onCancel={onClose}
      onAccept={() => {
        unblockHost.mutate(hostId, {
          onSuccess: onClose,
        });
      }}
    >
      <p className="p m-0">
        {hostKind(host) === 'lighthouse' ?
          <>
            Unblocking <Code className="wrap-anywhere">{host.name}</Code> will restore it to your network, making it
            available in the lighthouse pool for peer discovery.
          </>
        : <>
            Unblocking <Code className="wrap-anywhere">{host.name}</Code> will allow it to rejoin your network and make
            connections with other hosts, lighthouses, and relays.
          </>
        }
      </p>
    </ConfirmDialog>
  );
}
